import { Component, OnInit, Inject, Input, SimpleChanges, NgZone, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AccidentService } from '../../services/accident.service'
import { UtilityService } from '../../services/utility.service'
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component'
import { Observable } from 'rxjs';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
declare var $: any;
import * as _ from 'lodash';
import { MapsAPILoader } from '@agm/core';
import { MapsService } from 'src/app/services/maps.service';
import { accidentType, reporterForm } from '../../_models/staticArray'
import { staticLocation } from '../../_models/staticArray';

@Component({
  selector: 'app-add-accident-modal',
  templateUrl: './add-accident-modal.component.html',
  styleUrls: ['./add-accident-modal.component.scss']
})
export class AddAccidentModalComponent implements OnInit {
  accident: FormGroup;
  date
  placeholder = "Date"
  newdateFormate
  errorFromserver
  loading: boolean;
  modelTitle
  isSubmit: boolean = false
  isValidation = true
  files: any = [];
  newFiles: any = []
  createByEdit
  latitude = staticLocation.latitude
  longitude = staticLocation.longitude
  zoom: number;
  address = staticLocation.address
  map: google.maps.Map;
  bounds
  geoCoder
  previousIndex: any;
  isMapEdit: boolean
  // isSubmit: boolean = false
  userRole = JSON.parse(localStorage.getItem('userRoles'))
  currentDate = new Date()
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  @Input('materialObject') materialObject: any;
  @Input('accident') accidentData
  @Input('user') userData
  @Input('documentData') documentDetails
  accidentType = accidentType;
  // accidentType = [{ key: 'Accident/Near Miss', value: 'nearMiss' }, { key: 'Close Call', value: 'closeCall' }, { key: 'Good Practise', value: 'goodPractice' }]

  reporterForm = reporterForm
  constructor(private _mapsService: MapsService, private mapsAPILoader: MapsAPILoader, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public dialogRef: MatDialogRef<AddAccidentModalComponent>, private _utilityService: UtilityService, private _accidentService: AccidentService, public _snackBar: MatSnackBar, private ngZone: NgZone,) {
  }


  ngOnInit() {
    this.loading = false;
    console.log('hello check edit data..', this.data)
    if (this.data && this.data.edit == true) {
      this.isMapEdit = true
      this.createByEdit = this.data.createdBy
      this.modelTitle = 'Edit Incident'
      this.date = this.data.date;
      this.files = this.data.files
      this.newFiles = (this.data.newFiles) ? this.data.newFiles : []
      this.latitude = this.data && this.data.location ? this.data.location.coords.lat : ''
      this.longitude = this.data && this.data.location ? this.data.location.coords.lng : ''
      console.log("here is the latitude", this.latitude, this.longitude)
      this.address = this.data && this.data.location ? this.data.location.address : ''
      // this.address = this.data.location.address
    } else {
      this.isMapEdit = false
      this.modelTitle = 'Add Incident'
      // this.setCurrentLocation();
    }

    this.createForm()
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   console.log("changes", changes);
  //   if (changes.file && changes.file.currentValue) {
  //     this.files = changes.file.currentValue
  //   }
  // }



  createForm() {
    let date = new Date();
    let newdateFormate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
    this.accident = new FormGroup({
      title: new FormControl((this.data && this.data.title) ? this.data.title : ''),
      // location: new FormControl((this.data && this.data.location) ? this.data.location : ''),
      date: new FormControl((this.data && this.data.date) ? this.data.date : newdateFormate),
      type: new FormControl((this.data && this.data.type) ? this.data.type : ''),
      description: new FormControl((this.data && this.data.description) ? this.data.description : ''),
      userForm: new FormControl('')
    })
    if (this.data && this.data.type && this.data.type === 'closeCall') {
      // this.accident.addControl('ELR', new FormControl(this.data.details.ELR));
      // this.accident.addControl('mileage', new FormControl(this.data.details.mileage));
      // this.accident.addControl('closecallRadio1', new FormControl(this.data.details.closecallRadio1));
      // this.accident.addControl('closecallRadio2', new FormControl(this.data.details.closecallRadio2));
      // this.accident.addControl('pcReport', new FormControl(this.data.details.pcReport));
    }
  }


  onChange(value) {
    this.date = value;
    this.accident.patchValue({ date: this.date })
    console.log("event call sucessfully", this.accident.value)
  }

  addFileModal() {


    let obj = {
      isIncident: true,
    }

    // if (this.materialId != undefined) {
    let addedCourse = this.openDialog(NewFileModalComponent, obj).subscribe((fileQueue) => {
      console.log("The queue recieved is", fileQueue);
      if (fileQueue == undefined || fileQueue.length == 0) return;

      _.forEach(fileQueue, (file) => {
        if (this.data && this.data.edit == true) {
          this.newFiles.push(file)
          console.log("new file-->", this.newFiles);
        } else {
          this.files.push(file);
          console.log("file-->", this.files);
        }
      })

    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }



  deleteFile(event) {
    console.log("event if file removed", event, this.data.edit);
    this.files.splice(event, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event) {
    this.newFiles.splice(event, 1)
  }


  selectedTypeChanged(event) {
    console.log("event", event);
    // if (event.value && event.value === 'closeCall') {
    //   this.accident.addControl('ELR', new FormControl(''));
    //   this.accident.addControl('mileage', new FormControl(''));
    //   this.accident.addControl('closecallRadio1', new FormControl(''));
    //   this.accident.addControl('closecallRadio2', new FormControl(''));
    //   this.accident.addControl('pcReport', new FormControl(''));
    // }
  }


  // Google Maps Functions

  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
  }
  deleteDialog() {

    console.log("hello this delete accident data !!!", this.accident.value)
    // let data = this.accident.value;
    let id = this.data._id
    const dialogRef = this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, "accident")
      .afterClosed().subscribe((confirm) => {

        if (confirm == '') return
        else if (confirm == 'yes') {

          /**
           * delete accident confirm when call 
           */

          this._accidentService.deleteAccident(id)
            .subscribe((data) => {
              console.log('Hello response data here ==>', data)
              let responseData = {
                accident: data.data.accident,
                lastAccidentDate: data.lastAccidentDate
              }
              this._utilityService.closeDialog(this.dialogRef, responseData)
            }, (error) => {
              console.log('delete accident some error occure!!!', error)
            })

        }
      })
  }

  submitAccident() {
    if (this.accident.valid) {
      this.loading = true;
      this.isSubmit = false;

      // if (this.accident.value['type'] === 'closeCall') {
      //   let obj = {
      //     ELR: this.accident.value['ELR'],
      //     mileage: this.accident.value['mileage'],
      //     closecallRadio1: this.accident.value['closecallRadio1'],
      //     closecallRadio2: this.accident.value['closecallRadio2'],
      //     pcReport: this.accident.value['pcReport']
      //   }
      //   delete this.accident.value['ELR']
      //   delete this.accident.value['mileage']
      //   delete this.accident.value['closecallRadio1']
      //   delete this.accident.value['closecallRadio2']
      //   delete this.accident.value['pcReport']

      //   console.log("THIS IS THE CLOSE CALL EXTRA DETAILS", obj)
      // }
      
      if (this.data && this.data.edit == true) {
        if (this.accident.value['type'] === 'closeCall') this.accident.value['details'] = this.data.details || {}
        console.log("hello this edit accident data !!!", this.data)
        let data = this.accident.value;
        data['_id'] = this.data._id
        data['files'] = this.data.files
        data['newFiles'] = this.newFiles
        data['user'] = this.createByEdit._id;
        this.accident.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        console.log("data==>", data);
        this._accidentService.editAccident(data).subscribe((data) => {
          console.log('Hello response data here ==>', data)
          // this.files = []
          // res['isDelete'] = false
          // res['_id'] = this.data._id
          // res['createdBy'] = this.data.createdBy
          // data['files'] = this.data.files
          // this._utilityService.closeDialog(this.dialogRef, res)
          data.data.accident['newFiles'] = this.newFiles
          data.data.accident['location'] = {
            coords: { lat: this.latitude, lng: this.longitude },
            address: this.address
          }
          data.data.accident['files'] = this.files
          data.data.accident['createdBy'] = this.createByEdit;

          let responseData = {
            accident: data.data.accident,
            lastAccidentDate: data.lastAccidentDate
          }

          this._utilityService.closeDialog(this.dialogRef, responseData)
          this.loading = false
        }, (error) => {
          console.log('edit accident some error occure!!!', error)
          this.errorFromserver = error.msg
          this.loading = false
        }

        )
      }
      else {
        this.accident.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        // console.log("this.accident.value", this.accident.value['type'], this.accident.value);
        // console.log("hello this accident data !!!", this.accident.value, this.files)
        this._accidentService.addAccident(this.accident.value, this.files)
          .subscribe((data) => {
            console.log("this data response return data", data)
            let responseData = {
              accident: data.data.accident,
              lastAccidentDate: data.lastAccidentDate
            }
            this.loading = false;
            this._utilityService.closeDialog(this.dialogRef, responseData)
          }, (error) => {
            this.loading = false;
            console.log("this err return in accident submit time")

            this.errorFromserver = error.msg
            console.log("this.errorform server message", error)
          })
      }
    } else {
      this.isSubmit = true;
    }
  }
}
